// @flow
import React from 'react';
import { LatLongParamContainer } from './LatLongParamContainer';
import TaxiTypeContainer from './TaxiTypesContainer';

type Props = {
  disableInput: boolean,
  handleCityChange: Function,
  handleTimeoutChange: Function,
  handleProviderTypeChange: Function,
  handlePickupLatLongChange: Function,
  fillCity: Function,
  fillProviderTypes: Function,
  cohortID: String,
  showCohortLocationModal: Function,
  latlongParams: String,
  providerType: number,
  taxiTypes: Array<any>,
  handleTaxiTypeChange: Function,
  toggleAdvanceParams: Function,
  showAdvanceSimulationParams: boolean,
}

export default function CommonSimulationParams(props: Props) {
  return (
    <div className="common-params">
      <div className="field columns">
        <div className="label column is-half" htmlFor="timeout">Set Duration <br /> (in minutes)</div>
        <div className="field column is-half">
          <input
            name="timeout"
            type="number"
            className="input"
            onChange={props.handleTimeoutChange}
            disabled={props.disableInput}
            defaultValue={5}
          />
        </div>
      </div>
      <div className="field columns">
        <div className="label column is-half" htmlFor="city">City</div>
        <div className="select column is-half">
          <select
            name="city"
            onChange={props.handleCityChange}
            disabled={props.disableInput}
          >
            {props.fillCity()}
          </select>
        </div>
      </div>
      <div className="field columns">
        <div className="label column is-half" htmlFor="providerType">Location Behavior</div>
        <div className="select column is-half">
          <select
            name="providerType"
            onChange={props.handleProviderTypeChange}
            disabled={props.disableInput}
          >
            {props.fillProviderTypes()}
          </select>
        </div>
      </div>
      <LatLongParamContainer
        disableInput={props.disableInput}
        latlongParams={props.latlongParams}
        showCohortLocationModal={props.showCohortLocationModal}
        handlePickupLatLongChange={props.handlePickupLatLongChange}
        providerType={props.providerType}
      />
      <button
        className="button"
        onClick={props.toggleAdvanceParams}
        type="button"
        disabled={props.disableInput}
      >
        {(props.showAdvanceSimulationParams)
          ? 'Hide Advanced Simulation Behaviors'
          : 'Show Advanced Simulation Behaviors'}
      </button>
      <TaxiTypeContainer
        taxiTypes={props.taxiTypes}
        handleTaxiTypeChange={props.handleTaxiTypeChange}
        showAdvanceSimulationParams={props.showAdvanceSimulationParams}
      />
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/js/views/autosim/simulation/components/CommonSimulationParams.jsx
 **/